<template>
  <el-dialog
    width="632px"
    :visible="true"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <div slot="title">
      <div class="el-dialog__title">
        <template v-if="locationType === locationTypes.iBeacon">
          {{ $t('CampaignForm_AddLocationDialog_Title_IBeacon') }}
        </template>
        <template v-if="locationType === locationTypes.geo">
          {{ $t('CampaignForm_AddLocationDialog_Title_GeoFence') }}
        </template>
      </div>
    </div>
    <rest-list
      :top-data="topData"
      :payload="locationsFetchEndpoint"
      :watch-payload="false"
      :after-fetch="afterFetch"
      @dataLoaded="setData($event)"
      @selection-change="selectionChange($event)"
      ref="list"
      :max-height="500"
    >
      <template v-if="data[0]">
        <el-table-column type="selection" align="center" />
        <rest-list-column
          :title="$t('CampaignForm_AddLocationDialog_Title_Column')"
          prop="title"
        />
      </template>
    </rest-list>
    <span slot="footer">
      <el-button type="primary" plain @click="applyLocation">
        <span>{{ $t('Campaign_Dialog_Button_Apply') }}</span>
        <i class="el-icon-arrow-right el-icon--right" />
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import { projectEndpoint } from '@/core/helpers'
import RestList from '@/common/components/rest/RestList'
import { locationTypes } from '@/modules/campaign-manage/components/locations/locationsEnum'
import RestListColumn from '@/common/components/rest/RestListColumn'

export default {
  name: 'AddLocationDialog',
  components: { RestListColumn, RestList },
  props: {
    locationType: Number,
    locations: Array
  },

  data() {
    return {
      locationTypes,
      skipFirstChange: false,
      selectedItems: [],
      topData: [],
      data: {}
    }
  },

  created() {
    this.selectedItems = this.locations.filter(element => {
      return element.type === this.locationType
    })
  },

  computed: {
    locationsFetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'locations',
        params: {
          type: this.locationType
        }
      })
    }
  },

  methods: {
    afterFetch() {
      this.$nextTick(_ => {
        this.selectionChange(this.selectedItems)
      })
    },

    selectionChange(items) {
      // filter triggers selectionChange, so skip it for the first time and select the previous elements
      if (this.skipFirstChange) {
        this.skipFirstChange = false
        this.toggleSelection(this.selectedItems)
      } else {
        this.selectedItems = items
      }
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.list.$refs['el-table'].toggleRowSelection(row)
        })
      } else {
        this.$refs.list.$refs['el-table'].clearSelection()
      }
    },

    setData(data) {
      this.topData = []
      this.data = Object.assign({}, this.data, data)

      if (this.selectedItems.length) {
        this.selectedItems.forEach((val, index) => {
          // Update selected items and place them at the top of the table
          let updatedSelectedItem = data.find(item => item.id === val.id)
          if (updatedSelectedItem) {
            this.selectedItems[index] = updatedSelectedItem
          }
        })
        this.topData = this.selectedItems
        this.skipFirstChange = true
      }
    },

    handleClose() {
      this.$refs.list.filterField('title', null)
      EventBus.$emit('addLocationDialog', null)
    },

    applyLocation() {
      EventBus.$emit('applyLocation', {
        selection: this.selectedItems,
        type: this.locationType
      })
    }
  }
}
</script>

<style scoped>
>>> .el-checkbox__input.is-indeterminate .el-checkbox__inner,
>>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #1d87c8;
  border-color: #1d87c8;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/locations/AddLocationDialog.vue